import InvoiceDurationCard from "~/components/Metrics/InvoiceDurationCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const InvoiceDuration = ({ posId }: { posId: string }) => {
  const { t } = useTranslation();
  const getInvoiceDuration = async (query: MetricsAPI.GetMetricQuery) => {
    try {
      const { data } = await api.metrics.getInvoiceDurationByPOS({
        posId,
        ...query,
      });
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <InvoiceDurationCard
      title={`${t("title.invoiceDurationBy")} POS: ${posId}`}
      onUpdate={getInvoiceDuration}
    />
  );
};

export default InvoiceDuration;
